import React, { Component } from "react";
import { connect } from "react-redux";
import configureStore from "../../../store/configureStore";
import { get_courses } from "../../../actions/action-course";
import {
  create_course_user,
  get_all_course_users,
} from "../../../actions/action-courseuser";

import { get_all_orguesr } from "../../../actions/action-orguser";

import Button from "@material-ui/core/Button";
import Loader from "../../common/Loader";
import { history } from "../../../reducers";
import SidebarWrapper from "../../layout/SidebarWrapper";
import CommonSnackBar from "../../common/CommonSnackBar";
import FormButton from "../../common/FormButton";
import { Input, Paper, TextField } from "@material-ui/core";
import { timeFormat } from "../../common/CommonFunctions";
import { setActiveOuid } from "../../../actions/action-permissions";
import Typography from "@material-ui/core/Typography";
import SearchField from "../../common/SearchField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from "axios";
import { showSnackbar } from "../../../actions/action-snackbar";
import CourseCard from "../../pages/Post/CourseCard";
import Select from "react-select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const store = configureStore();
let selectedUserName = "";
let selectedCourseId = "";
let selectedCourse = "";
let selectedCourseData = "";

class SubscriptionDash extends Component {
  constructor() {
    super();
    this.state = {
      coursesToShow: [],
      courseOptionsToShow: [],
      usersToShow: [],
      userOptionsToShow: [],
      courseUsersToShow: [],
    };
  }

  componentDidMount() {
    if (!this.props.auth.isAuthenticated) {
      const path = window.location.pathname;
      history.push(`/login?redirect=${path}`);
      return;
    }
    this.fetchDetails();
  }

  componentDidUpdate() {
    console.log("componentDidUpdate");
  }

  async fetchDetails() {
    const path = window.location.pathname.split("/");
    const ouid = path[1];
    console.log("fetchDetails ouid : ", ouid);

    const { activeOuid, activeOuidChain } = store.getState().permission;

    console.log(" fetchDetails activeOuid : ", activeOuid);
    console.log("fetchDetails permission : ", store.getState().permission);

    const {
      setActiveOuid,
      get_all_orguesr,
      get_courses,
      get_all_course_users,
    } = this.props;

    await setActiveOuid(ouid);
    await get_all_orguesr(activeOuid);
    const { orgUserProfiles } = store.getState().orgUserProfile;

    console.log("fetchDetails > orgUserProfiles : ", orgUserProfiles);

    await get_courses(activeOuid, activeOuidChain, "", activeOuid);
    const { courses } = store.getState().course;
    console.log("fetchDetails > courses : ", courses);
    console.log(" get_all_orguesr activeOuid : ", activeOuid);
    let userOptionsToShow = orgUserProfiles.map((opt) => ({
      label: opt.data.username,
      value: opt.data.username,
    }));
    let courseOptionsToShow = courses.map((opt) => ({
      label: opt.data.title,
      value: opt.data.identifier,
      data: opt.data,
    }));

    await get_all_course_users(activeOuid, activeOuidChain);
    const { courseUsers } = store.getState().courseuser;

    this.setState({
      coursesToShow: courses,
      courseOptionsToShow: courseOptionsToShow,
      usersToShow: orgUserProfiles,
      userOptionsToShow: userOptionsToShow,
      courseUsersToShow: courseUsers,
    });
  }

  handleCourseOnChange(courseOption) {
    console.log(courseOption.value);
    selectedCourseId = courseOption.value;
    selectedCourse = courseOption.label;
    selectedCourseData = courseOption.data;

    console.log(courseOption.data);
  }

  handleUserOnChange(userOption) {
    console.log(userOption.value);
    selectedUserName = userOption.value;
  }

  addSubscription = async (event) => {
    console.log(selectedCourseId, selectedUserName);
    const { create_course_user } = this.props;
    let courseUserPayload = {
      courseId: selectedCourseId,
      courseuser: selectedUserName,
      course: selectedCourse,
      courseData: selectedCourseData,
    };
    await create_course_user(courseUserPayload);
    this.fetchDetails();
  };

  renderCourses(courseList) {
    const { showGlobalLoader } = store.getState().course;
    return (
      <>
        <div>
          <section className="section">
            {showGlobalLoader ? (
              <Loader />
            ) : (
              <>
                <div className="container">
                  Select Course
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={true}
                    isSearchable={true}
                    name="color"
                    options={this.state.courseOptionsToShow}
                    onChange={(opt) => this.handleCourseOnChange(opt)}
                  />
                </div>
              </>
            )}
            <CommonSnackBar />
          </section>
        </div>
      </>
    );
  }

  renderCourseUsers(courseusers) {
    console.log("courseusers : ", JSON.stringify(courseusers));
    return courseusers.map((row) => (
      <TableRow key={row.data.username}>
        <TableCell>{row.data.courseuser}</TableCell>
        <TableCell>{row.data.course}</TableCell>
        <TableCell>{row.data.courseId}</TableCell>
        <TableCell>{row.data.createdBy}</TableCell>
      </TableRow>
    ));
  }

  renderUsers(userList) {
    const { orgUserProfiles, showGlobalLoader } =
      store.getState().orgUserProfile;

    console.log("renderUsers >orgUserProfiles ", orgUserProfiles);
    return (
      <section className="section">
        {showGlobalLoader ? (
          <Loader />
        ) : (
          <div className="container">
            Select User
            <Select
              className="basic-single"
              classNamePrefix="select"
              isClearable={true}
              isSearchable={true}
              name="color"
              options={this.state.userOptionsToShow}
              onChange={(opt) => this.handleUserOnChange(opt)}
            />
          </div>
        )}
      </section>
    );
  }

  render() {
    const { permissions } = store.getState().permission;

    return (
      <div className="page">
        <SidebarWrapper auth={this.props.auth} permissions={permissions} />
        <section className="section">
          <div className="container">
            <div>{this.renderUsers(this.state.usersToShow)}</div>
            <div>{this.renderCourses(this.state.coursesToShow)}</div>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.addSubscription()}
            >
              Add Subsciption
            </Button>
            <div className="List">
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell className="TableHeader">Username</TableCell>
                      <TableCell className="TableHeader">Course</TableCell>
                      <TableCell className="TableHeader">CourseId</TableCell>
                      <TableCell className="TableHeader">CreatedBy</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.courseUsersToShow.length !== 0
                      ? this.renderCourseUsers(this.state.courseUsersToShow)
                      : "No Subscriptions Yet"}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  orgunit: state.orgunit,
  showGlobalLoader: state.orgunit.showGlobalLoader,
  permission: state.permission,
});

const mapDispatchToProps = (dispatch) => ({
  setActiveOuid: (activeOuid) => dispatch(setActiveOuid(activeOuid)),
  get_all_orguesr: (activeOuid) => dispatch(get_all_orguesr(activeOuid)),
  get_all_course_users: (activeOuid, activeOuidChain) =>
    dispatch(get_all_course_users(activeOuid, activeOuidChain)),
  get_courses: (activeOuid, activeOuidChain, category, ouid) =>
    dispatch(get_courses(activeOuid, activeOuidChain, category, ouid)),
  create_course_user: (payload) => dispatch(create_course_user(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionDash);
